<header>
  <h2 id="loginWelcomeText">{{signInWelcomeText}}</h2>
  <h4 *ngIf="signInWelcomeSecondaryText" class="mt-2">{{signInWelcomeSecondaryText}}</h4>
</header>
<form class="signinForm" [formGroup]="signinForm" (ngSubmit)="onSubmit()">
  <div class="errors message-box message--warning" *ngIf="authFailText">
    <p id="invalidLoginErrorMessage" [innerHTML]="authFailText"></p>
  </div>
  <div class="email">
    <mat-form-field appearance="outline">
      <input data-automation-id="input_login_email" matInput placeholder="Enter your email address" formControlName="email">
    </mat-form-field>
    <div *ngIf="email.touched && email.errors">
      <mat-error *ngIf="email.errors?.email">
        Enter a valid email address
      </mat-error>
      <mat-error *ngIf="email.errors?.required">
        Enter an email address
      </mat-error>
    </div>
  </div>
  <div class="password">
    <mat-form-field appearance="outline">
      <input matInput data-automation-id="input_login_password" placeholder="Enter your password" [type]="hide ? 'password' : 'text'" formControlName="password">
      <button mat-icon-button matSuffix (click)="toggleHide()" type="button">
        <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
      </button>
    </mat-form-field>
    <mat-error *ngIf="password.touched && password.errors?.required">
      Enter a password
    </mat-error>
  </div>
  <a class="forgotpassword" [routerLink]="['/auth/forgotpassword']">Forgot Password?</a>
  <div>
    <button id="loginSubmitButton" class="a-rounded-button a-rounded-button--primary" type="submit"
            [disabled]="signinForm.invalid" data-automation-id="button_login_submit">{{loginButtonText}}</button>
    <button *ngIf="enableAwsCognitoLogin" class="a-rounded-button a-rounded-button--primary-outline" type="button" (click)="initiateSamlAuth()">{{ssoLoginButtonText}}</button>
  </div>
</form>
<footer>
  <p id="loginRegisterLink" *ngIf="displayRegister">Haven't got an account? <a routerLink="/register">Register</a></p>
  <p id="loginEmailForRegistrationLink" *ngIf="showSendEmailForRegistration">Haven't got an account? <a href={{contactUsForRegistrationLink}} target="_blank">Contact us</a></p>
  <p *ngIf="showContactUs" [innerHTML]="contactUsHtml">
      <a href={{contactUsLink}} target="_blank">Contact us</a>
  </p>
  <p *ngIf="showCreateNewAccountText">
    <br />
    {{createNewAccountText}} <a href={{createNewAccountLink}} target="_blank">{{createNewAccountLinkText || 'here.'}}</a>
  </p>
  <div *ngIf="footerHtml" [innerHtml]="footerHtml"></div>
</footer>
<app-spinner *ngIf="showSpinner" class="fullscreen-spinner"></app-spinner>
